import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_inventory_by_license_plate_lotService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_id?: number, license_plate?: number, location?: number, package_id?: number, warehouse_id?: number, lot_id?: number, full_text_search?: string }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, LocationId?: number, MaterialId?: number, WarehouseId?: number, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string } } }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_inventory_by_license_plate_lot/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { material_id?: number, license_plate?: number, location?: number, package_id?: number, warehouse_id?: number, lot_id?: number, full_text_search?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, LocationId?: number, MaterialId?: number, WarehouseId?: number, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_inventory_by_license_plate_lot/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_id?: number, license_plate?: number, location?: number, package_id?: number, warehouse_id?: number, lot_id?: number, full_text_search?: string, $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, LocationId?: number, MaterialId?: number, WarehouseId?: number, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_inventory_by_license_plate_lot/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_id?: number, license_plate?: number, location?: number, package_id?: number, warehouse_id?: number, lot_id?: number, full_text_search?: string    }) {
      return false;
    }
}
